document.addEventListener('DOMContentLoaded', () => {
    // slick default setting
    let defaulsettings = {
        loop: true,
        speed: 700,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: '.swiper-prev',
            prevEl: '.swiper-next'
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        }
    };

    

    // start slider default
    let allSwipper =[];

    document.querySelectorAll('.swiper-slider').forEach((element,i) => {

        let swiperConfig = element.dataset.swiper ? JSON.parse(element.dataset.swiper) : defaulsettings;
        element.setAttribute(`data-swiper-${i}`,"");
        let swiper = new Swiper(`[data-swiper-${i}]`, swiperConfig);
        allSwipper[i] = swiper;

    });

    const slider_swiper = new Swiper('.slider-swiper', {
        slidesPerView: 1,
		centeredSlides: true,
		spaceBetween: 10,
		speed: 800,
		loop: true,
        autoHeight: true,
        navigation: {
			prevEl: ".slider-prev-arrow",
			nextEl: ".slider-next-arrow",
		},
        breakpoints:{
            640: {
                slidesPerView: 1.35,
                autoHeight: false
            },
            1030:{
                slidesPerView: 1.7,
            }
        }
    });
    console('hello')
    console('hello')
});